import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { Box, makeStyles } from '@material-ui/core';
import { Link } from '@reach/router';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FontSizes } from '../../../../core/config/mainTheme';
import { getPath } from '../../../../core/utils/routes.utils';
import { useCompaniesState } from '../../../../pages/FinancialData/shared/CompanyContext/CompanyContext';
import { ROUTES } from '../../../../routes';

interface OwnProps extends ICellRendererParams {
  benchmarkId?: string;
}

const LinkCellRenderer: React.FC<OwnProps> = ({ value, data, benchmarkId }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { dataset, dbVersion } = useCompaniesState();
  const label = value && value !== '' ? value : t('companies:unknown');

  if (data?.companyInfo?.id) {
    const path = getPath(ROUTES.benchmarking.refinementCompany, ROUTES.financialData.company, {
      benchmarkId,
      companyUid: data.companyInfo.id,
      dataset,
      dbVersion,
    });
    return (
      <Link to={path} className={classes.link}>
        {label}
      </Link>
    );
  }

  return <Box className={classes.link}>{label}</Box>;
};

const useStyles = makeStyles((theme) => ({
  link: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textDecoration: 'none',
    color: theme.palette.primary.main,
    fontWeight: FontSizes.fontWeight.bold,
    cursor: 'pointer',
    marginLeft: -1 * (theme.spacing(6) + 1),
    marginRight: -1 * (theme.spacing(6) + 1),
    paddingLeft: theme.spacing(6),
  },
}));

export default LinkCellRenderer;
